// Site link declaration
export enum SITELINKS {
  NON = "*",
  MAIN = "/",
  LOGOUT = "/",
  HOW_IT_WORKS = "/how-it-works",

  // COMMON LINKS
  SIGNIN = "/login-tepnguser",
  CONSENT_FORM = "/tepnguser/personal-data-and-cookies-consent-form",

  // ADMIN LINKS
  DASHBOARD_ADMIN = "/tepnguser/dashboard",
  USERS = "/tepnguser/users/manage",
  VENDORS = "/tepnguser/vendors/manage",
  ASSESSMENT_FORM = "/tepnguser/inspection/assessment-form",
  INSERVICE_ASSESSMENT_FORM = "/tepnguser/inspection/inservice-assessment-form",
  INSPECTION_HISTORY = "/tepnguser/inspection",
  INSPECTION_APPROVAl_HISTORY = "/tepnguser/inspection-approval",
  ROLES = "/tepnguser/users/roles",
  INSPECTION = "/tepnguser/inspection/vessel-inspection",
  SEGMENT = "/tepnguser/inspection/segment-form",
  ASSESSMENT = "/tepnguser/inspection/assessment-form",
  MANAGE_SEGMENT = "/tepnguser/inspection/manage-segment-form",
  MANAGE_DEFECT_CHECKLIST = "/tepnguser/inspection/manage-defect-checklist",
  MANAGE_EQUIPMENT = "/tepnguser/inspection/manage-equipment",
  MANAGE_FUNCTIONALEMAIL = "/tepnguser/inspection/manage-functional-email",
  MANAGE_VESSEL_CATEGORY = "/tepnguser/inspection/Manage-vessel-category",
  MANAGE_VESSELS = "/tepnguser/inspection/Manage-vessels",
  TRACKER = "/tepnguser/inspection/action-tracker",
  COMPANY = "/tepnguser/users/company",
  NOTIFICATION = "/tepnguser/notification",
  MANUAL_TEPNG = "/tepnguser/manual",
  HELP = "/tepnguser/help",
  VERIFY_SIGNIN = "/verify-sign-in",
  BROADCAST = "/broadcast",
  BROADCAST_HISTORY = "/broadcast-history",
  REQUEST = "/request",
  RESPONSES = "/responses",
  SUBSCRIPTIONS = "/subscriptions",
  CREATE_USER = "/user/create",
  UPDATE_USER = "/user/update/",
  USER_PROFILE = "/user/",
  APP_INSIGHT = "/app-insight",
  VESSEL_REPORT = "/vessel-report",
  ADMIN_ACTION_TRACKER = "/tepnguser/action-tracker",
  ADMIN_VIEW_TRACKER = "/tepnguser/view-action-tracker",

  // MARINESUPERINTENDENT
  DASHBOARD_MARINESUPERINTENDENT = "/marine-superintendent/dashboard",
  INSPECTION_MARINESUPERINTENDENT = "/marine-superintendent/inspection",
  ASSESSMENT_MARINESUPERINTENDENT = "/marine-superintendent/inspection-assessment-form",
  INSERVICE_MARINESUPERINTENDENT = "/marine-superintendent/inspection-inservice-form",
  ASSESSMENT_MARINESUPERINTENDENT_OFFLINE = "/template",
  MARINE_ACTION_TRACKER = "/marine-superintendent/action-tracker",
  CREATE_TRACKER = "/marine-superintendent/create-action-tracker",
  VIEW_TRACKER = "/marine-superintendent/view-action-tracker",
  MANUAL_MS = "/marine-superintendent/ms-manual",
  MARINESUPERINTENDENT_VESSEL_REPORT = "/marine-superintendent/vessel-report",

  // VESSEL OPERATOR
  ONBOARDING = "/onboarding",
  SIGNIN_VO = "/login",
  RESET_PASSWORD = "/reset-password",
  UPDATE_PASSWORD = "/update-password",
  DASHBOARD_VO = "/dashboard",
  VO_TRACKER = "/action-tracker",
  VO_VIEW_TRACKER = "/view-action-tracker",
  VO_CREATE_TRACKER = "/create-action-tracker",
  VO_INSPECTION = "/inspection-history",
  VO_VIEW_INSPECTION = "/view-inspection",
  VO_VIEW_INSERVICE = "/view-inservice-inspection",
  MANUAL_VO = "/vo-manual",
}
